import { render, staticRenderFns } from "./single-confidence.vue?vue&type=template&id=8c97cdb6&scoped=true&"
import script from "./single-confidence.vue?vue&type=script&lang=ts&"
export * from "./single-confidence.vue?vue&type=script&lang=ts&"
import style0 from "./single-confidence.vue?vue&type=style&index=0&id=8c97cdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c97cdb6",
  null
  
)

export default component.exports